"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helperClassCssFixer = void 0;
var bowser_1 = __importDefault(require("bowser"));
var helperClassCssFixer = function () {
    var browser = bowser_1.default.getParser(window.navigator.userAgent);
    if (browser.satisfies({ ie: '11' })) {
        document.body.className += ' shark-ie';
        return;
    }
    if (browser.satisfies({ edge: '>=15' })) {
        document.body.className += ' shark-edge';
        return;
    }
    if (browser.satisfies({ safari: '<=11' })) {
        document.body.className += ' shark-ios-10';
        return;
    }
};
exports.helperClassCssFixer = helperClassCssFixer;
//# sourceMappingURL=index.js.map